import { useState, useEffect } from 'react';

/**
 * Custom hook to track the device pixel ratio (DPR)
 * Updates on mount and when the window is resized
 * @returns The current device pixel ratio (defaults to 1.27 for kiosk hardware)
 */
export function useDpr(): number {
  const [dpr, setDpr] = useState(1.27);

  useEffect(() => {
    const updateDpr = () => {
      setDpr(window.devicePixelRatio || 1);
    };

    updateDpr();
    window.addEventListener('resize', updateDpr);

    return () => {
      window.removeEventListener('resize', updateDpr);
    };
  }, []);

  return dpr;
}
